export const API_BASE_URL = 'https://wvg-greifswald.jobrouter.cloud';
export const API_WIDGET = 'custom-applications/widgets';
//https://wvg-greifswald.test.jobrouter.cloud/